<div class="login-page">
    <div class="login-page-form">
        <div class="login-form-logo"></div>
        <form
            name="form"
            (ngSubmit)="f.form.valid && processForm();f.reset()"
            #f="ngForm"
            novalidate
        >
            <div class="login-page-form-content">
                <!-- -USER-NAME -->
                <div class="form-group">
                    <mat-form-field>
                        <input
                            type="text"
                            matInput
                            placeholder="Username"
                            [(ngModel)]="username"
                            name="uname"
                            #uname="ngModel"
                            required
                        >
                        <mat-error *ngIf="f.submitted && uname.invalid">Username is required</mat-error>
                    </mat-form-field>
                </div>
                <!-- -PASSWORD -->
                <div class="form-group">
                    <mat-form-field>
                        <input
                            passwordValidator
                            type="password"
                            matInput
                            placeholder="Password"
                            [(ngModel)]="password"
                            name="psw"
                            #psw="ngModel"
                            required
                        >
                        <mat-error *ngIf="psw.touched && psw.invalid">Please enter valid password</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="login-page-form-actions">
                <button
                    mat-raised-button
                    color="primary"
                    class="mat-button-large"
                    type="submit"
                    [disabled]="!f.valid"
                >
                    Login
                </button>
            </div>
        </form>
    </div>
</div>
